var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":_vm.color,"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9 1L3.667 5 1 2.333"}})])}
var staticRenderFns = []

export { render, staticRenderFns }